import React from 'react';
interface SectionCardProps {
  /** Rendered as the card's heading. Omit for a card with no title row. */
  title?: React.ReactNode;
  /** Small text opposite the title. */
  meta?: React.ReactNode;
  /** Applied to the outer card, e.g. to change its surface. */
  className?: string;
  children: React.ReactNode;
}

/**
 * One bordered card per section. Sections on profile pages are distinct kinds
 * of information, so they get distinct containers rather than a run of rules.
 */
export function SectionCard({
  title,
  meta,
  className = '',
  children
}: SectionCardProps) {
  const headingId = typeof title === 'string' ? title.replace(/\s+/g, '-').toLowerCase() : undefined;
  return <section aria-labelledby={headingId} className={`rounded-card border border-rule bg-card ${className}`} data-id="element-545" data-mp="2mvu27x4q878o">
      {title ? <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1 border-b border-rule px-5 py-4" data-id="element-546" data-mp="2itfkjgcsndiz">
          <h2 id={headingId} className="text-heading font-semibold text-ink" data-id="element-547" data-mp="2dwyxkphbz57h">
            {title}
          </h2>
          {meta ? <span className="text-small text-ink-muted" data-id="element-548" data-mp="yf9rbjoglo34">{meta}</span> : null}
        </div> : null}
      <div className="px-5 py-5" data-id="element-549" data-mp="knvbflpum30a">{children}</div>
    </section>;
}